import './App.css';
import WeatherApp from './components/WeatherApp';

function App() {
  return (
    <div className="App">
      <WeatherApp /> 
    </div>
  );
}

export default App;
